import { createRouter, createWebHashHistory } from 'vue-router';
import Electro3Component from '../components/Electro3Component.vue';
import Noticias from '../components/Noticias.vue';
import SobreNosotros from '../components/SobreNosotros.vue';
import NuestrosPartners from '../components/NuestrosPartners.vue';
import NuestrosServicios from '../components/NuestrosServicios.vue';
import Electro3Contact from '../components/Electro3Contact.vue';
import VartaComponent from '../components/VartaComponent.vue';
import VartaSilver from '../components/Varta/VartaSilver.vue';
import VartaBlue from '../components/Varta/VartaBlue.vue';
import VartaBlack from '../components/Varta/VartaBlack.vue';
import VartaMineria from '../components/Varta/VartaMineria.vue';
import VartaContact from '../components/Varta/VartaContact.vue';
import PoliticaPrivacidad from '../components/PoliticaPrivacidad.vue'; // Importa el componente de la política de privacidad

const routes = [
  {
    path: '/',
    name: 'home',
    component: Electro3Component,
    children: [
      {
        path: 'Noticias',
        name: 'Noticias',
        component: Noticias
      },
      {
        path: 'SobreNosotros',
        name: 'SobreNosotros',
        component: SobreNosotros
      },
      {
        path: 'NuestrosPartners',
        name: 'NuestrosPartners',
        component: NuestrosPartners
      },
      {
        path: 'NuestrosServicios',
        name: 'NuestrosServicios',
        component: NuestrosServicios
      },
      {
        path: 'Contacto',
        name: 'Contacto',
        component: Electro3Contact
      },
    ]
  },
  {
    path: '/politica-privacidad',  // Nueva ruta para la Política de Privacidad
    name: 'PoliticaPrivacidad',
    component: PoliticaPrivacidad // Asocia la ruta con el componente
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/varta',
    name: 'VartaComponent',
    component: VartaComponent,
    children: [
      {
        path: 'silver',
        name: 'VartaSilver',
        component: VartaSilver
      },
      {
        path: 'Blue',
        name: 'VartaBlue',
        component: VartaBlue
      },
      {
        path: 'Black',
        name: 'VartaBlack',
        component: VartaBlack
      },
      {
        path: 'Mineria',
        name: 'VartaMineria',
        component: VartaMineria
      },
      {
        path: 'Contact',
        name: 'VartaContact',
        component: VartaContact
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// Redireccionamiento basado en el dominio
router.beforeEach((to, from, next) => {
  const domain = window.location.hostname;

  if (domain === 'varta.com.ar' && to.path === '/') {
    next({ path: '/varta' }); 
  } else {
    next(); 
  }
});

export default router;
